import { DOMUtil, Logger, LogManager } from "@mcleod/core";
import { Component } from "../base/Component";
import { Panel } from "../components/panel/Panel";
import { ScreenStack } from "../components/panel/ScreenStack";

export class KeyHandlerGroupRefresher {
    private static _log: Logger;

    public static refresh(comp: Panel | HTMLElement) {
        const currentScreen = ScreenStack.getCurrentScreen();
        const innerElement = (comp instanceof Panel) ? comp._element : comp;
        this.getLog().debug("Resolved inner element: %o", innerElement);
        if (currentScreen != null && DOMUtil.isOrContains(currentScreen._element, innerElement)) {
            this.getLog().debug("Refreshing key handler group for current screen: %o, key handler group: %o",
                currentScreen, currentScreen.getKeyHandlerGroup());
            currentScreen.fillKeyHandlerGroup(true);
            this.getLog().debug("Key handler group after refresh: %o", currentScreen.getKeyHandlerGroup());
            return;
        }
        const currentOverlay = ScreenStack.getNewestOverlay();
        if (currentOverlay != null && DOMUtil.isOrContains(currentOverlay.getOverlayContent()._element, innerElement)) {
            this.getLog().debug("Refreshing key handler group for current overlay: %o, key handler group: %o",
                currentOverlay, currentOverlay.getKeyHandlerGroup());
            currentOverlay.fillKeyHandlerGroup(true);
            this.getLog().debug("Key handler group after refresh: %o", currentOverlay.getKeyHandlerGroup());
            return;
        }
    }

    /**
     * This convenience method allows for the refresh of the outermost layout (i.e. the root layout) that contains a
     * lower-level panel/component.
     * @param panel The lower-level panel/component that causes the update.  The panel or component's root layout will
     *              have its key handler group refreshed.
     */
    public static refreshOutermostLayout(component: Component) {
        const outermostLayout = component.getRootLayout();
        if (outermostLayout != null) {
            KeyHandlerGroupRefresher.refresh(outermostLayout);
        }
    }

    private static getLog(): Logger {
        if (this._log == null) {
            this._log = LogManager.getLogger("components.keyhandling.KeyHandlerGroupRefresher");
        }
        return this._log;
    }
}
